const mediaItems = [
  {
    title: '暑期档热映：《时空旅人》终极预告',
    desc: '穿越时空的冒险之旅，视觉效果震撼，剧情层层反转',
    duration: '02:35',
    views: '128万',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20scene%20still%20with%20dramatic%20lighting%20and%20warm%20color%20grading%2C%20movie%20theater%20aesthetic%2C%20soft%20film%20grain%2C%20professional%20cinematography%20look%2C%20dark%20atmospheric%20background%2C%20golden%20and%20crimson%20accents&width=800&height=450&seq=media-thumb-04&orientation=landscape',
  },
  {
    title: '经典回顾：《教父》修复版精彩片段',
    desc: '影史不朽经典 4K 修复，马龙·白兰度巅峰演技',
    duration: '05:12',
    views: '96万',
    img: 'https://readdy.ai/api/search-image?query=Vintage%20classic%20cinema%20scene%20with%20dramatic%20chiaroscuro%20lighting%2C%20film%20noir%20aesthetic%2C%20deep%20shadows%20and%20warm%20highlights%2C%20classic%20Hollywood%20style%2C%20elegant%20dark%20composition%2C%20timeless%20cinematic%20mood&width=800&height=450&seq=media-thumb-05&orientation=landscape',
  },
  {
    title: '新剧速递：《暗夜追踪》第一集精剪',
    desc: '韩国烧脑悬疑大作，第一集即高能不断引人入胜',
    duration: '03:48',
    views: '203万',
    img: 'https://readdy.ai/api/search-image?query=Suspenseful%20thriller%20scene%20with%20moody%20blue%20and%20amber%20lighting%2C%20detective%20noir%20atmosphere%2C%20rain%20slicked%20streets%2C%20neon%20reflections%2C%20dark%20cinematic%20composition%2C%20modern%20film%20aesthetic&width=800&height=450&seq=media-thumb-06&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-1 h-6 bg-accent-500 rounded-full"></span>
          <h2 className="text-foreground-900 font-heading text-2xl md:text-3xl font-bold">
            精彩片段
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item, idx) => (
            <div key={idx} className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/60 cursor-pointer">
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-background-50/20 group-hover:bg-background-50/10 transition-colors"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:scale-110 transition-all">
                    <i className="ri-play-fill text-background-50 text-xl md:text-2xl ml-0.5"></i>
                  </span>
                </div>
                <span className="absolute bottom-2 right-2 bg-background-50/90 text-foreground-700 text-xs px-2 py-0.5 rounded whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-foreground-900 font-heading text-sm md:text-base font-bold mb-1.5 line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2 mb-2">
                  {item.desc}
                </p>
                <span className="text-foreground-400 text-xs">
                  <i className="ri-eye-line mr-1"></i>{item.views} 次观看
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}